<template>
  <div class="container__div">
    <div class="py-3">
      <el-radio-group v-model="route" fill="#0A50E6" text-color="#73c9ff">
        <el-radio-button label="Pedidos">
          <router-link
            :to="{ name: 'DemoOrders' }"
            class="no-underline font-neue uppercase"
          >
            Pedidos
          </router-link>
        </el-radio-button>
        <el-radio-button label="Enviados a Nirex">
          <router-link
            :to="{ name: 'DemoList' }"
            class="no-underline font-neue uppercase"
          >
            Enviados a Nirex
          </router-link>
        </el-radio-button>
      </el-radio-group>
    </div>
    <h2 class="text-2xl text-white">Lista de Pedidos</h2>
    <div class="w-full flex justify-between">
      <select class="text-dark-purple w-1/2 mr-4 py-2 pl-5">
        <option disabled selected>Seleccionar origen</option>
        <option
          v-for="item in options"
          :key="item.address"
          :label="item.address"
          :value="item"
        />
      </select>

      <select class="text-dark-purple w-1/2 py-2 pl-5">
        <option disabled selected>Selecciona tipo de vehículo</option>
        <option
          v-for="item in tipos"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </select>
    </div>

    <div class="flex justify-center mt-4 table__example">
      <el-table
        ref="multipleTable"
        :data="tableData"
        class="table__style"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="Direccion">
          <template slot-scope="scope">
            {{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column label="Contacto" width="120">
          <template slot-scope="scope">
            {{ scope.row.contact.name }}
          </template>
        </el-table-column>
        <el-table-column label="Celular" width="120">
          <template slot-scope="scope">
            {{ scope.row.contact.phone }}
          </template>
        </el-table-column>
        <el-table-column
          property="instructions"
          label="instrucciones"
          show-overflow-tooltip
        />
        <el-table-column label="Estado" width="120">
          <template slot-scope="scope">
            {{ scope.row.state }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex justify-start my-5">
      <button
        class="bg-green-neon py-3 px-4 text-dark-purple uppercase font-neue"
        @click="createOrder"
      >
        Enviar Orden
      </button>
    </div>
    <div
      v-if="errors.length"
      class="flex justify-start mx-10 my-5"
      style="width: 70%"
    >
      <el-alert
        v-for="(error, index) in errors"
        :key="index"
        :title="error.msg"
        type="error"
        effect="dark"
      />
    </div>
    <div
      v-if="success"
      class="flex justify-start mx-10 my-5"
      style="width: 60%"
    >
      <el-alert
        title="Se creo la orden con exito"
        type="success"
        effect="dark"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      form: {
        order: {
          service: "programmed",
          vehicle: "",
          points: [],
        },
        verification: {
          amount: 1000,
          card_id: "",
          distance: 4399,
        },
      },

      options: [
        {
          lat: -12.1799109,
          lng: -77.0029409,
          address:
            "ChorrillosGuitar, Avenida Guardia Peruana, Chorrillos, Perú",
          tempId: "string",
          instructions: "Casa Azul",
          ok: true,
          contact: {
            name: "Joel vilca",
            phone: "953553629",
          },
        },
      ],
      tipos: [
        {
          value: "moto",
          label: "Moto",
        },
        {
          value: "auto",
          label: "Auto",
        },
      ],
      type: "",
      origin: "",
      tableData: [
        {
          lat: -12.1799109,
          lng: -77.0029409,
          address:
            "ChorrillosGuitar, Avenida Guardia Peruana, Chorrillos, Perú",
          tempId: "string",
          instructions: "Casa Azul",
          state: "Listo",
          ok: true,
          contact: {
            name: "Joel vilca",
            phone: "953553629",
          },
        },
        {
          lat: 0,
          lng: 0,
          address: "Bernardo O'Higgins, La Esperanza, Perú",
          tempId: "string",
          instructions: "puerta verde",
          ok: true,
          state: "Listo",
          contact: {
            name: "Carlos cotta",
            phone: "953553629",
          },
        },
        {
          lat: -12.121991,
          lng: -77.0307022,
          address: "Miraflores kenedy, Diagonal, Miraflores, Perú",
          tempId: "string",
          instructions: "super market",
          ok: true,
          state: "Listo",
          contact: {
            name: "Brandon lee",
            phone: "953553629",
          },
        },
        {
          lat: -12.0780101,
          lng: -77.086629,
          address: "san miquel, Avenida la Marina, Cercado de Lima, Perú",
          tempId: "string",
          instructions: "puerta azul",
          ok: true,
          state: "Listo",
          contact: {
            name: "Aldo jordan",
            phone: "953553629",
          },
        },
        {
          lat: -12.047305,
          lng: -77.08509029999999,
          address:
            "CARMEN DE LA LEGUA, Avenida Argentina, Cercado de Lima, Perú",
          tempId: "string",
          instructions: "casa blanca",
          state: "Listo",
          ok: true,
          contact: {
            name: "Alberto juan",
            phone: "953553629",
          },
        },
        {
          lat: -12.0874119,
          lng: -77.03523950000002,
          address: "Belgravia, Avenida Arenales, Lince, Perú",
          tempId: "string",
          instructions: "casa verde",
          ok: true,
          state: "Listo",
          contact: {
            name: "brayan",
            phone: "953553629",
          },
        },
      ],
      points: [],
      errors: [],
      success: false,
      route: "Pedidos",
    };
  },
  methods: {
    async createOrder() {
      if (this.points.length) {
        this.points.unshift(this.origin);
      } else {
        this.points.push(this.origin);
      }
      this.form.order.points = this.points;
      try {
        await axios.post("https://api.nirex.pe/api/orders", this.form, {
          headers: {
            Key: "69a92ae5-a860-411b-8745-6de5016db145",
            "Content-Type": "application/json",
          },
        });
        this.success = true;
      } catch (error) {
        if (error.response.status === 400) {
          this.errors = error.response.data.errors;
        }
      }
    },
    handleSelectionChange(raw) {
      this.points = raw;
    },
  },
};
</script>
<style lang="scss" scoped>
.el-select {
  margin-top: 20px;
  width: 500px;
  margin-left: 40px;
}
.table__example {
  height: 48vh;
  overflow-y: scroll;
  @media only screen and (min-width: 1500px) {
    height: 58vh;
  }
}
.table__style {
  width: 100%;
  overflow-y: scroll;
}
.container__div {
  max-width: 1360px;
  margin: 0 auto;

  @media only screen and (max-width: 1361px) {
    padding: 0 4%;
  }
}
</style>
